module.exports = __webpack_public_path__ + "img/usability-1.36bbcc74.png";